import Vue from 'vue'
import Router from 'vue-router'
import iView from 'iview';
import storage from '@/store/storage'
import req from '@/util/req'
import * as _util from '@/util/util'
import Full from '@/containers/Full'
import store from '@/store/index'

Vue.use(Router);

const globalRoutes = [{
    path: '/login',
    name: 'login',
    component: (resolve) => require(['@/components/login/login'], resolve),
    meta: {}
}, {
    path: '/gdplan',
    name: 'gdplan',
    component: (resolve) => require(['@/components/map/GDmap'], resolve),
    meta: {}
}]

var defaultPath = '/dataKanban';//租户默认路径
var iframePath = '';// ifarme内嵌地址
const platform_defaultPath = '/platKanban';//平台默认路径

const mainRoutes = {
    path: '/',
    name: '',
    component: Full,
    meta: {
        breadcrumb: '首页'
    },
    children: []
}

const router = new Router({
    routes: globalRoutes.concat(mainRoutes),
    menuAdd: false, //是否已经添加动态(菜单)路由
});
var powerUrl = '/dataKanban'

const isNotToken = (to, next) => {
  //不传osstoken,执行的路由
  var _storage = storage;
  var token = _storage.getToken();
  var user = storage.getUser();
  if (token) { //登录未过期
    if (router.options.menuAdd || isGlobalRoutes(to)) {
      let menus = JSON.parse(localStorage.getItem("tr_tr_menus"));
      if (menus) {
        menus.forEach((item) => {
          if (item.powerName == "地磅看板") {
            powerUrl = item.powerUrl;
          }
        });
        if(menus[0].children.length != 0){
          defaultPath = menus[0].children[0].powerUrl
        } 
        else{
          defaultPath = iframePath? iframePath: menus[0].powerUrl
        }
      }
      if (to.name === 'login') {//已经有toke访问login时跳转
        storage.setLoginState(false);
        if (user) {
          if (user.unitId == window.globle.unit) {
            next({
              path: platform_defaultPath
            });
          } else {
            next({
              path: defaultPath
            });
          }
        }
        else {
          next();
        }
      }
      else {
        if (user.unitId == window.globle.unit) { //判断是否是平台还是租户
          if (_storage.getLoginState()) {
            next();
          }
          else {
            if (to.path == platform_defaultPath) {
              _storage.setLoginState(true)
              next();
            }
            else {
              next({
                path: platform_defaultPath
              });
            }
          }
        }
        else {
          if (_storage.getLoginState()) { //this
            next();
          }
          else {
            if (to.path == defaultPath) {
              _storage.setLoginState(true)
              next();
            }
            else {
              next({
                path: defaultPath
              });
            }
          }
        }
      }
    }
    else {
      addDynamicMenu()
      next({
        ...to,
        replace: true
      })
    }
  }
  else { //登录已过期
    _storage.setLoginState(false)
    if (to.path == '/login') {
      next();
    } else {
      next({
        path: '/login'
      });
    }
  }
}

router.beforeEach((to, from, next) => {
  iView.LoadingBar.start();
  if (to.query.token) {
    iframePath = to.path
    // console.log(this.a.app,'thisa ');
    this.a.app.$store.commit('setIframeToken',to.query.token)
    // console.log(this.a.app.$store.state.iframeToken,'我在这');
    ossRoute(to, next, to.query.token)
  }
  else {
      isNotToken(to, next);
  }
});

//校验token
const ossCheck = function (ossToken) {
  let param = new FormData();
  param.append("ossToken", ossToken);
  return new Promise((resolve, reject) => {
    req.post(param, api.ossLogin, (_r) => {
      let res = _r.data;
      store.dispatch("bindLogin", res);
      resolve();
    }, () => {
      reject();
    })
  });
};

const ossRoute = async (to, next, ossToken) => {
    var token = storage.getToken();
    var user = storage.getUser();
    if (token) {
      if (to.path == '/login') {
        if (user.unitId == window.globle.unit) {
          next({
            path: platform_defaultPath
          });
        }
        else {
          next({
            path: defaultPath
          });
        }
      }
      else {
        next({
          path: to.path
        });
      }
    }
    else {
      await ossCheck(ossToken).then((res) => {
        next({
          path: defaultPath
        });
      }).catch((res) => {
        next();
        return _util._notify.error('token校验异常!');
      })
    }
}

const addDynamicMenu = () => {
    let menus = storage.getMenus();
    //let menus = store.state.user.menu;
    menus.forEach(menu => {
        mainRoutes.children.push(backendMenusToRouters(menu))
    })
    router.options.menuAdd = true;
    router.addRoutes([ //vue-routers2.2版本以上才支持。
        mainRoutes
    ])

}

const backendMenusToRouters = (menu) => {
    if (!menu.compUrl) { //未配置组件url 则默认组件url=powerUrl
        menu.compUrl = menu.powerUrl
    }
    let route = {
        path: menu.powerUrl,
        name: menu.powerCode,
        component: resolve => {
            require(['@/views' + menu.compUrl], resolve)
        },
        meta: {
            breadcrumb: menu.powerName
        },
        children: []
    }
    if (menu.children && menu.children.length !== 0 && menu.name != "") {
        menu.children.forEach(sub => {
            route.children.push(backendMenusToRouters(sub));
        })
    }
    return route
}

//判断当前是否全局路由
function isGlobalRoutes(to) {
    for (let i in globalRoutes) {
        if (globalRoutes[i].path == to.path) {
            return true;
        }
    }
    return false;
}

router.afterEach(route => {
    iView.LoadingBar.finish();
    window.scrollTo(0, 0);
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js